module.exports = __webpack_public_path__ + "img/email-icon.87a12e0c.svg";